import http from "../utils/http";
import { toast } from "../utils/toast";

// 공지사항 등록
export const createNotice = (params, type = 'notice') => {
  return new Promise((resolve, reject) => {
    http
      .post(`/boards/${type}/post`, params)
      .then((res) => {
        toast.success('공지사항이 등록되었습니다.');
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 공지사항 목록
export const getNoticeList = (params, type = 'notice') => {
  return new Promise((resolve, reject) => {
    http
      .post(`/boards/${type}/posts`, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};



// 공지사항 삭제
export const deleteNotice = (idx, type = 'notice') => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/boards/${type}/post/${idx}`)
      .then((res) => {
        toast.success('공지사항이 삭제되었습니다.');
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 공지사항 삭제
export const deleteNotices = (data, type = 'notice') => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/boards/${type}/post`, { data })
      .then((res) => {
        toast.success('공지사항이 삭제되었습니다.');
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 공지사항 수정
export const modifyNotice = (params, type = 'notice') => {
  return new Promise((resolve, reject) => {
    http
      .put(`/boards/${type}/post`, params)
      .then((res) => {
        toast.success('공지사항이 수정되었습니다.');
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};


export const createBoard = (params, type = 'notice') => {
  return new Promise((resolve, reject) => {
    http
      .post(`/boards/${type}/post`, params)
      .then((res) => {
        toast.success('공지사항이 등록되었습니다.');
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getBoardList = (params, type = 'notice') => {
  return new Promise((resolve, reject) => {
    http
      .post(`/boards/${type}/posts`, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};



export const deleteBoard = (idx, type = 'notice') => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/boards/${type}/post/${idx}`)
      .then((res) => {
        toast.success('공지사항이 삭제되었습니다.');
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const modifyBoard = (params, type = 'notice') => {
  return new Promise((resolve, reject) => {
    http
      .put(`/boards/${type}/post`, params)
      .then((res) => {
        toast.success('공지사항이 수정되었습니다.');
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const boardShare = (params) => {
  return new Promise((resolve, reject) => {
    http.post(`/boards/share`, params).then((res) => {
      toast.success('전체공지가 개시되었습니다.');
      resolve(res);
    })
      .catch((err) => {
        reject(err);
      });
  });
};

export const boardList = (params) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/boards/post/list`, params)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 공지사항 삭제
export const deleteBoards = (data) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/boards/post`, { data })
      .then((res) => {
        toast.success('공지사항이 삭제되었습니다.');
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
